import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export var FLASH_TIMER = 100;
export var FAST_TIMER = 300;
export var TIMER = 500;
export var SLOW_TIMER = 1000;